/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_PolishInputs */



/**
* | output |
* | --- |
* | "Polish" |
*
* @param {Speechmatics_Target_Language_PolishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_polish = /** @type {((inputs?: Speechmatics_Target_Language_PolishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_PolishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Polonais")
	if (locale === "de") return /** @type {LocalizedString} */ ("Polieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Polacco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("польский")
	if (locale === "es") return /** @type {LocalizedString} */ ("Polaco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("抛光")
	if (locale === "ja") return /** @type {LocalizedString} */ ("研磨")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पोलिश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("polonês")
	return /** @type {LocalizedString} */ ("Polish")
});